import { createSelector } from 'reselect';
import { FormState } from 'ia-react-core/~/interfaces/FormState';

import get from '../../utils/accessors/get';
import some from '../../utils/accessors/some';

const isDeeplySubmittingSelector = () => createSelector(
  (formState: FormState) => get(formState, 'isSubmitting'),
  (formState: FormState) => get(formState, 'forms'),
  (isSubmitting: boolean, forms: FormState['forms']) => {
    if (isSubmitting) {
      return isSubmitting;
    }

    return some(forms, (form) => {
      const isDeeplySubmitting = get(form, 'isDeeplySubmitting');
      const isFormList = (typeof isDeeplySubmitting === 'undefined');

      if (isFormList) {
        return some(form, (repeatedForm) => get(repeatedForm, 'isDeeplySubmitting'));
      }

      return isDeeplySubmitting;
    });
  },
);

/**
 * @component
 * @visibleName isDeeplySubmittingSelector
 */
export default isDeeplySubmittingSelector;
